import { Box } from "@mui/material"
import type { FC } from "react"

import { resolveSoftReceivedPurchaseOrderEstimatedTotals } from "../../utils"
import { GoodsReceiptPurchaseOrderPanel } from "../GoodsReceiptDetails"

import { SoftReceivedPurchaseOrderLineForm } from "./SoftReceivedPurchaseOrderLineForm"

import type { GoodsReceiptProductDetail, Order } from "@/graphql/codegen/graphql"

interface SoftReceivedPurchaseOrderFormProps {
  purchaseOrder: Order
  purchaseOrderIndex: number
  goodsReceiptLines: GoodsReceiptProductDetail[]
  isResettingRef?: React.MutableRefObject<boolean>
  isSubtotalsVisible?: boolean
  onRemove?: (purchaseOrderId: number) => void
}

export const SoftReceivedPurchaseOrderForm: FC<SoftReceivedPurchaseOrderFormProps> = ({
  purchaseOrder,
  purchaseOrderIndex,
  goodsReceiptLines,
  isResettingRef,
  isSubtotalsVisible = true,
  onRemove,
}) => {
  const estimatedTotals = resolveSoftReceivedPurchaseOrderEstimatedTotals(
    purchaseOrder.orderLines ?? [],
    goodsReceiptLines
  )

  return (
    <GoodsReceiptPurchaseOrderPanel
      key={purchaseOrder.orderId}
      purchaseOrder={purchaseOrder}
      totals={estimatedTotals}
      onRemove={onRemove}
    >
      <Box className='flex flex-col gap-y-6'>
        {purchaseOrder.orderLines?.map((purchaseOrderLine, purchaseOrderLineIndex) => (
          <SoftReceivedPurchaseOrderLineForm
            key={purchaseOrderLine.orderLineId}
            purchaseOrderLine={purchaseOrderLine}
            goodsReceiptLines={goodsReceiptLines}
            purchaseOrderIndex={purchaseOrderIndex}
            purchaseOrderLineIndex={purchaseOrderLineIndex}
            isResettingRef={isResettingRef}
            isSubtotalsVisible={isSubtotalsVisible}
          />
        ))}
      </Box>
    </GoodsReceiptPurchaseOrderPanel>
  )
}
